module.exports = __webpack_public_path__ + "img/kyc-denied.15a56dd1.svg";